import $ from "jquery";

const contentNewsArchive = () => {
  // used element
  const el = {
    pagination: ".pagination-item a",
    search: "#search-event",
    pageName: "input[name='page_name']",
    card: ".wrapper-card-news",
    eventPerPage: "input[name='event_per_page']",
  };

  const init = () => {
    if ($(el.pageName).val() != "evenementen") return;

    searchAjax();
    paginationAjax();
  };

  const searchAjax = () => {
    $(document).on("input", el.search, function (e) {
      const $thisEl = $(e.target);
      //   const post_per_page = $thisEl.data("post_per_page");
      const postPerPage = $(el.eventPerPage).val();

      updateCurrentUrl(1, $thisEl.val());
      requestData(1, $thisEl.val(), postPerPage);
    });
  };

  const paginationAjax = () => {
    $(document).on("click", el.pagination, function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const $thisEl = $(e.target);
      const paginationUrl = $thisEl.attr("href");

      const pagedValue = extractPageNumber(paginationUrl);
      const searchValue = getSearchValue();
      const postPerPage = $(el.eventPerPage).val();

      updateCurrentUrl(pagedValue, searchValue, postPerPage);
      requestData(pagedValue, searchValue, postPerPage);
    });
  };

  const updateCurrentUrl = (page = 1, search = false) => {
    // Get the current URL
    const url = new URL(window.location.href);

    if (search) {
      url.searchParams.set("search", search);
    } else {
      url.searchParams.delete("search");
    }

    if (containPageNumber(url.toString())) {
      url.pathname = changePageNumber(url.pathname, page);
    } else {
      url.pathname += "page/" + page;
    }

    url.searchParams.delete("filters");

    // Replace the current state in the browser history
    window.history.replaceState({}, document.title, url.toString());
  };

  const containPageNumber = (url) => {
    const pattern = /\/page\/\d+\/?/;
    return pattern.test(url);
  };

  const changePageNumber = (pathName, newPageNumber = 1) => {
    const pattern = /\/page\/(\d+)\/?/;
    const updatedUrl = pathName.replace(
      pattern,
      "/page/" + newPageNumber + "/"
    );

    return updatedUrl;
  };

  const getSearchValue = () => {
    return $(el.search).val();
  };

  const extractPageNumber = (url) => {
    // Extract the path from the URL
    const path = new URL(url).pathname;

    // Use a regular expression to match the page number in the path
    const match = path.match(/\/page\/(\d+)\/?$/);

    if (match) {
      // Return the matched page number
      return parseInt(match[1]);
    }

    // Default to 1 if page number is not found
    return 1;
  };

  /**
   * request data to ajax
   * @param {array} input
   */
  const requestData = (paged = 1, search = false, post_per_page) => {
    // run loading animations
    $(el.card).addClass("loading");

    let data = {
      // eslint-disable-next-line no-undef
      nonce: themeObj.ajax.nonce,
      // eslint-disable-next-line no-undef
      action: themeObj.ajax.event.action,
      paged: paged,
      posts_per_page: post_per_page,
    };

    if (search) {
      data.search = search;
    }

    $.ajax({
      url: themeObj.ajaxUrl, // eslint-disable-line no-undef
      type: "POST",
      dataType: "json",
      data: data,
    })
      .done(function (r) {
        $(el.card).empty();
        $(el.card).html(r.data);
      })
      .always(function () {
        // stop loading animations
        $(el.card).removeClass("loading");
      });
  };

  init();
};

try {
  contentNewsArchive();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
